/** @jsxImportSource @emotion/react */
import { css, keyframes } from '@emotion/react';

const spin = keyframes`
  to { transform: rotate(360deg); }
`;

const SPINNER_STYLE = css`
  label: SPINNER_STYLE;
  border: 2px solid currentColor;
  border-top-color: transparent;
  border-radius: 50%;
  animation: ${spin} 0.6s linear infinite;
  opacity: 0.8;
`;

export const Spinner = ({ size = 18 }: { size?: number }) => <div css={SPINNER_STYLE} style={{ width: size, height: size }} aria-label='Loading' />;
